import React from "react";
import { decorate, observable, action, computed } from "mobx";
import { uniqBy } from "lodash";
import { Divider } from "@material-ui/core";

class HideFieldsStore {
  anchorEl = null;
  viewStore = null;

  constructor(props) {
    this.viewStore = props.viewStore;
    this.columns = null;
  }

  setAnchorEl = (event) => {
    this.anchorEl = event.currentTarget;
    this.columns = this.getSortedColumns();
  };

  handleClose = () => {
    const me = this;
    me.anchorEl = null;
  };

  getAllColumns() {
    return this.columns;
  }

  get allColumns() {
    const viewColumns = this.viewStore.view.options.columns.map(col => {
      return this.viewStore.containerStore.listConfig.listData.find(
        (listCol) => listCol.alias_path === col.alias_path
      ) || col;
    })
    const commentsIdColumn = {
      id: "comments_id",
      name: "Notes/Comments",
      col_width: 250,
      dataIndex: "comments_id",
      column_type_id: "comments_id",
      alias_path: "commentsId",
      text: "",
      list_id: this.viewStore?.view?.list_id,
      header: "Notes/Comments",
      alias_name: "comments",
    };
    let columns = [...viewColumns, ...this.viewStore.newColumns, ...this.viewStore.containerStore.listConfig.listData];  
    if (commentsIdColumn) {
      columns.unshift(commentsIdColumn); // Using unshift() to add the column at the beginning
    }
    if (
      this.viewStore?.view?.type == "table" &&
      this.viewStore?.view?.list_id &&
      this.viewStore?.view?.options?.main_list_id &&
      this.viewStore?.view?.list_id != this.viewStore?.view?.options?.main_list_id
    ) {
      this.viewStore?.containerStore?.listConfig?.listData?.map((col) => {
        if (col.column_type_id == "6") {
          let options =
            typeof col.options == "string"
              ? JSON.parse(col.options)[0]
              : col.options;
          if (options?.sub_list_id == this.viewStore?.view?.options?.main_list_id) {
            let subSheetColumns =
              col.list_columns?.length >= 1
                ? JSON.parse(JSON.stringify(col.list_columns))
                : [];
            subSheetColumns.map((subSheetColumn) => {
              // if (!subSheetColumn.hasOwnProperty("alias_path")) {
                subSheetColumn["alias_path"] =
                  String(col.alias_path) + "." + String(subSheetColumn.alias_name);
                subSheetColumn.list_id = col.list_id;
              // }
            });
            columns = [...subSheetColumns, <Divider/>, ...columns];
          }
        }
      });
    }
    if (this.viewStore?.listConfig?.list?.is_log_sheet) {
      columns = columns.filter(col => col.name !== "CurrentJSONData");
    }
    return uniqBy(columns, "alias_path");
  }

  get checkedValues() {
    return this.viewStore.columnDefs.filter((col) => {
      return col.colId !== "Id" && col.colId !== "+" && col.hide === false
    }).map(col => col.aliasPath);
  }

  get checkedColumns() {
    return this.allColumns.filter(col => this.checkedValues.includes(col.alias_path));
  }

  get uncheckedColumns() {
    return this.allColumns.filter(col => !this.checkedValues.includes(col.alias_path))
  }

  getSortedColumns = () => {
    return [...this.checkedColumns, ...this.uncheckedColumns]
  }

  getHiddenFieldsCount = () => {
    return this.uncheckedColumns.length;
  }

  handleMenuItemClick = async (menuItem) => {
    this.viewStore.isCommentsColumnPrev = null;
    if (menuItem.id === 'comments_id'){
      if(typeof this.viewStore?.view?.options?.options === "undefined") { 
        this.viewStore.view.options.options = {
          is_comments_column_visible : false
        } 
        this.viewStore.isCommentsColumnPrev = true;
      }
      else if (typeof this.viewStore?.view?.options?.options?.is_comments_column_visible === "undefined" || this.viewStore?.view?.options?.options?.is_comments_column_visible == true) {
          this.viewStore.view.options.options.is_comments_column_visible = false; 
          this.viewStore.isCommentsColumnPrev = true; 
      } else {
          this.viewStore.view.options.options.is_comments_column_visible = true;
          this.viewStore.isCommentsColumnPrev = false;
      }
    }
    const isNewColumnExists = this.viewStore.columnDefs.findIndex(
      (col) => col.aliasPath === menuItem.alias_path
    );
    const isChecked = this.checkedValues.indexOf(menuItem.alias_path);

    if (isNewColumnExists > -1) {
      this.viewStore.setColumnVisibility(menuItem, isChecked > -1);
      return;
    }

    var isColumnExist = this.columns.findIndex(
      (col) => col.alias_path === menuItem.alias_path
    );
    if (isColumnExist === -1) {
      this.columns.push(menuItem);
    }

    this.viewStore.showLookupColumnsInCurrentView(menuItem);

  };
}

decorate(HideFieldsStore, {
  anchorEl: observable,
  checkedValues: computed,
});

export default HideFieldsStore;
